import React, { useState, useEffect } from "react";
import { Grid, Text, Flex, Separator } from "@radix-ui/themes";
import { useProfileContext } from "context";
import { BrowseUnifiCard } from "./unifi/BrowseUnifiCard";
import { BrowseIntegrateCard, ToastAlert } from "components";
import { BrowseMailchimpCard } from "./mailchimp/BrowseMailchimpCard";
import { useGetActiveIntegrations } from "hooks";
import { BrowseAirshipCard } from "./airship/BrowseAirshipCard";
import { BrowseMetaCard } from "./meta/BrowseMetaCard";
import { BrowseAtreemoCard } from "./atreemo/BrowseAtreemoCard";
import { BrowseKlaviyoCard } from "./klaviyo/BrowseKlaviyoCard";
import { BrowseComoCard } from "./como/BrowseComoCard";
import { BrowseGoogleAdsCard } from "./google_ads/BrowseGoogleAdsCard";
import { BrowseBrevoCard } from "./brevo/BrowseBrevoCard";
import { BrowseDotdigitalCard } from "./dotdigital/BrowseDotdigitalCard";
import { BrowseLeatCard } from "./leat/BrowseLeatCard";
import { BrowseSevenRoomsCard } from "./sevenrooms/BrowseSevenRoomsCard";
import { BrowseWhatsappCard } from "./whatsapp/BrowseWhatsappCard";
import { BrowseGoogleReviewsCard } from "./google-reviews/BrowseGoogleReviewsCard";
import { BrowseTripadvisorReviewsCard } from "./tripadvisor-reviews/BrowseTripadvisorReviewsCard";
import { BrowseBrazeCard } from "./braze/BrowseBrazeCard";
import { BrowseBloomreachCard } from "./bloomreach/BrowseBloomreachCard";
import { BrowseEatAppCard } from "./eat-app/BrowseEatAppCard";
import { BrowseHubRiseCard } from "./hubrise/BrowseHubRiseCard";
import { BrowseClaudeCard } from "./claude/BrowseClaudeCard";

export default function BrowseIntegrations() {
  const { userProfile } = useProfileContext();

  const [openDialog, setOpenDialog] = useState({
    auth: false,
    detail: false,
  });

  const handleOpenChange = (dialog, isOpen) => {
    setOpenDialog((prev) => ({ ...prev, [dialog]: isOpen }));
  };

  const { data: activeIntegrationsData } = useGetActiveIntegrations(userProfile.organisation_id);
  const [integrationStatus, setIntegrationStatus] = useState({
    bconnect: "contact-support",
    extreme: "contact-support",
    cisco: "contact-support",
    tplink: "contact-support",
    cambium: "contact-support",
  });

  useEffect(() => {
    const isIntegrationActive = (integrationType) => {
      if (!activeIntegrationsData?.data?.integrations) {
        return false;
      } else {
        return activeIntegrationsData.data.integrations.some((integration) => integration.name === integrationType);
      }
    };

    setIntegrationStatus(integrateObject => ({
      ...integrateObject,
      bconnect: isIntegrationActive("bconnect") ? "active" : "contact-support",
      cisco: isIntegrationActive("cisco") ? "active" : "contact-support",
      extreme: isIntegrationActive("extreme") ? "active" : "contact-support",
      tplink: isIntegrationActive("tplink") ? "active" : "contact-support",
      cambium: isIntegrationActive("cambium") ? "active" : "contact-support",
    }));
  }, [activeIntegrationsData]);

  console.log("Integration Status:", integrationStatus);

  return (
    <Flex direction="column" gap="5" width="100%" style={{ alignSelf: "stretch", height: "100%", overflow: 'auto' }}>
      {/* Wi-Fi & Presence Section */}
      <Flex direction="column" gap="4">
        <Text size="4" weight="medium">Wi-Fi & Presence</Text>
        <Grid 
          columns={{ initial: "1fr", md: "repeat(2, minmax(0, 1fr))" }} 
          gap="5" 
          width="100%"
          style={{ overflow: "hidden" }}
        >
          <BrowseIntegrateCard.Root 
            name="b connect Wi-Fi" 
            subtitle="Wi-Fi" 
            image_url="favicon-light.png" 
            status={integrationStatus?.bconnect} openDialog={openDialog} 
            handleOpenChange={handleOpenChange}
          >
            <BrowseIntegrateCard.AuthDialog
              dialog_description="The URL could be a local address (e.g., https://192.168.1.100:8443), a remote server (e.g., https://controller.mybusiness.com:8443), or UniFi Cloud (https://unifi.ui.com)."
              onCancel={() => handleOpenChange("auth", false)}
            />
          </BrowseIntegrateCard.Root>
          <BrowseUnifiCard userProfile={userProfile} />
          <BrowseIntegrateCard.Root 
            name="Cambium Networks" 
            subtitle="Wi-Fi" 
            image_url="cambium-networks.png" 
            status={integrationStatus?.cambium} 
            openDialog={openDialog} 
            handleOpenChange={handleOpenChange}>
            <BrowseIntegrateCard.AuthDialog dialog_description="Cambium Networks integration is coming soon" onCancel={() => handleOpenChange("auth", false)} />
          </BrowseIntegrateCard.Root>

          <BrowseIntegrateCard.Root
            name="Cisco Meraki"
            subtitle="Wi-Fi and Presence analytics"
            image_url="cisco.png"
            status={integrationStatus?.cisco}
            openDialog={openDialog}
            handleOpenChange={handleOpenChange}
          >
            <BrowseIntegrateCard.AuthDialog dialog_description="Cisco Meraki integration is coming soon" onCancel={() => handleOpenChange("auth", false)} />
          </BrowseIntegrateCard.Root>

          <BrowseIntegrateCard.Root
            name="Extreme Networks"
            subtitle="Wi-Fi"
            image_url="extreme.png"
            status={integrationStatus?.extreme}
            openDialog={openDialog}
            handleOpenChange={handleOpenChange}
          >
            <BrowseIntegrateCard.AuthDialog dialog_description="Extreme Networks integration is coming soon" onCancel={() => handleOpenChange("auth", false)} />
          </BrowseIntegrateCard.Root>

          <BrowseIntegrateCard.Root
            name="Aruba Enterprise"
            subtitle="Wi-Fi and Presence analytics"
            image_url="aruba.png"
            status="contact-support"
            openDialog={openDialog}
            handleOpenChange={handleOpenChange}
          >
            <BrowseIntegrateCard.AuthDialog dialog_description="Aruba Enterprise integration is coming soon" onCancel={() => handleOpenChange("auth", false)} />
          </BrowseIntegrateCard.Root>

          <BrowseIntegrateCard.Root
            name="Aruba Instant On"
            subtitle="Wi-Fi and Presence analytics"
            image_url="aruba.png"
            status="contact-support"
            openDialog={openDialog}
            handleOpenChange={handleOpenChange}
          >
            <BrowseIntegrateCard.AuthDialog dialog_description="Aruba Instant On integration is coming soon" onCancel={() => handleOpenChange("auth", false)} />
          </BrowseIntegrateCard.Root>

          <BrowseIntegrateCard.Root 
            name="Meraki Go" 
            subtitle="Wi-Fi" 
            image_url="meraki-go.png" 
            status="contact-support" 
            openDialog={openDialog} 
            handleOpenChange={handleOpenChange}>
            <BrowseIntegrateCard.AuthDialog dialog_description="Meraki Go integration is coming soon" onCancel={() => handleOpenChange("auth", false)} />
          </BrowseIntegrateCard.Root>

          <BrowseIntegrateCard.Root 
            name="TP-Link Omada" 
            subtitle="Wi-Fi" 
            image_url="tp-link-omada.png"
            status={integrationStatus?.tplink}
            openDialog={openDialog} 
            handleOpenChange={handleOpenChange}>
            <BrowseIntegrateCard.AuthDialog dialog_description="TP-Link Omada integration is coming soon" onCancel={() => handleOpenChange("auth", false)} />
          </BrowseIntegrateCard.Root>
          {/* <BrowseTPLinkCard userProfile={userProfile} /> */}
        </Grid>
      </Flex>

      {/* Separator */}
      <Separator size="4" orientation="horizontal" style={{ minHeight: '1px'}} />

      {/* CRM & Marketing Section */}
      <Flex direction="column" gap="4">
        <Text size="4" weight="medium">Restaurant ordering</Text>
        <Grid columns={{ initial: "1", md: "2" }} gap="5" width="100%">
          <BrowseHubRiseCard userProfile={userProfile} />
        </Grid>
      </Flex>
      <Separator size="4" />

      <Flex direction="column" gap="4">
        <Text size="4" weight="medium">CRM & Marketing</Text>
        <Grid 
          columns={{ initial: "1fr", md: "repeat(2, minmax(0, 1fr))" }} 
          gap="5" 
          width="100%"
          style={{ overflow: "hidden" }}
        >
          <BrowseMailchimpCard userProfile={userProfile} />
          <BrowseAirshipCard userProfile={userProfile} />
          <BrowseMetaCard userProfile={userProfile} />
          <BrowseAtreemoCard userProfile={userProfile} />
          <BrowseKlaviyoCard userProfile={userProfile} />
          <BrowseComoCard userProfile={userProfile} />
          <BrowseGoogleAdsCard userProfile={userProfile} />
          <BrowseBrevoCard userProfile={userProfile} />
          <BrowseDotdigitalCard userProfile={userProfile} />
          <BrowseLeatCard userProfile={userProfile} />
          <BrowseSevenRoomsCard userProfile={userProfile} />
          <BrowseBrazeCard userProfile={userProfile} />
          <BrowseBloomreachCard userProfile={userProfile} />
          <BrowseEatAppCard userProfile={userProfile} />
          <BrowseWhatsappCard userProfile={userProfile} />
        </Grid>
      </Flex>

      <Separator size="4" orientation="horizontal" style={{ minHeight: '1px'}} />

      <Flex direction="column" gap="4">
        <Text size="4" weight="medium">Reviews</Text>
        <Grid 
          columns={{ initial: "1fr", md: "repeat(2, minmax(0, 1fr))" }} 
          gap="5" 
          width="100%"
          style={{ overflow: "hidden" }}
        >
          <BrowseGoogleReviewsCard userProfile={userProfile} />
          <BrowseTripadvisorReviewsCard userProfile={userProfile} />
        </Grid>
      </Flex>

      <Separator size="4" orientation="horizontal" style={{ minHeight: '1px'}} />

      <Flex direction="column" gap="4">
        <Text size="4" weight="medium">AI assistants</Text>
        <Grid
          columns={{ initial: "1fr", md: "repeat(2, minmax(0, 1fr))" }}
          gap="5"
          width="100%"
          style={{ overflow: "hidden" }}
        >
          <BrowseClaudeCard userProfile={userProfile} />
        </Grid>
      </Flex>

      <div style={{ position: "fixed", zIndex: 2147483647, pointerEvents: "none" }}>
        <ToastAlert />
      </div>
    </Flex>
  );
}
